// extracted by mini-css-extract-plugin
export default {"import-button":"styles_import-button__RFh0g","icon":"styles_icon__lPafM"};